var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Intum Video")]),_vm._v(" "),(!_vm.video)?_c('v-btn',{on:{"click":_vm.startVideo}},[_vm._v("\n    Start Video\n  ")]):_vm._e(),_vm._v(" "),_c('v-container',{ref:"meet1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }